import * as React from 'react';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';

import './ccm-campaigns-table-outfits-cell.scss';

applyTranslations(require('./ccm-campaigns-table-outfits-cell.i18n.json'));

import type {
  CampaignWithSubcampaignMeta
} from 'types';

type Props = {
  campaign: CampaignWithSubcampaignMeta
};

const MSG_KEY = 'ccm_campaigns_table_outfits_cell';

const CcmCampaignsTableOutfitsCell: React.FC<Props> = ({
  campaign
}): JSX.Element => {
  const renderSection = (
    key: 'maximum' | 'live',
    value: number
  ): React.ReactNode => {
    const containerClasses = classnames('ccm-campaigns-table-outfits-cell__section', {
      [`ccm-campaigns-table-outfits-cell__section--${key}`]: Boolean(key)
    });

    return (
      <div className={containerClasses}>
        <div className="ccm-campaigns-table-outfits-cell__label">
          {__t(`${MSG_KEY}.${key}`)}:
        </div>
        <div className="ccm-campaigns-table-outfits-cell__value">
          {value}
        </div>
      </div>
    );
  };

  return (
    <div className="ccm-campaigns-table-outfits-cell">
      {renderSection('maximum', campaign.maxOutfits || 0)}
      {renderSection('live', campaign.liveOutfitsCount || 0)}
    </div>
  );
};

export default CcmCampaignsTableOutfitsCell;
